import React from 'react';
import styled from '@emotion/styled';
import {
  Disclosure as BaseDisclosure,
  Box,
  Text,
} from '@qga/roo-ui/components';
import PropTypes from 'prop-types';

import { headerFontFamily } from '@/lib/theme/textStyles';

const defaultHeaderStyles = {
  fontFamily: headerFontFamily,
  fontWeight: 'bold',
  fontSize: ['20px', '24px'],
};

const StyledBox = styled(Box)`
  font-family: ${headerFontFamily};

  & button {
    ${({ isSmallTitle }) =>
      isSmallTitle &&
      `
      padding-top: 12px;
      padding-bottom: 16px;
    `}
  }

  & button + div {
    ${({ isSmallTitle }) =>
      isSmallTitle &&
      `
      padding-top: 0;
    `}
  }
`;

const Disclosure = ({
  headerStyles = {},
  variant = 'large',
  isSmallTitle = false,
  ...rest
}) => (
  <StyledBox isSmallTitle={isSmallTitle}>
    <BaseDisclosure
      headerStyles={{ ...defaultHeaderStyles, ...headerStyles }}
      variant={variant}
      {...rest}
    />
  </StyledBox>
);

Disclosure.propTypes = {
  headerStyles: PropTypes.shape(Text.propTypes),
  variant: PropTypes.string,
  isSmallTitle: PropTypes.bool,
  ...BaseDisclosure.propTypes,
};

export default Disclosure;
